import * as React from "react";
const CDMOSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={68}
    height={68}
    fill="none"
    {...props}
  >
    <rect
      width={60}
      height={60}
      x={4}
      y={4}
      fill="#040919"
      fillOpacity={0.02}
      rx={30}
    />
    <rect
      width={60}
      height={60}
      x={4}
      y={4}
      stroke="#040919"
      strokeOpacity={0.03}
      strokeWidth={8}
      rx={30}
    />
    <path
      fill="#040919"
      d="M44.2 22h-20a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V24a2 2 0 0 0-2-2Zm-15 16a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm-5-14h4v12.172a3 3 0 1 0 2 0v-3.758l6 6V44h-12V24Zm20 20h-6v-6a1.002 1.002 0 0 0-.293-.708l-7.708-7.706V24h4v3a1 1 0 0 0 .293.707l2 2a3 3 0 1 0 1.415-1.414l-1.708-1.707V24h8v20Zm-5-14a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
    />
  </svg>
);
export default CDMOSVG;
